export const CAR_BOOKING_ACTION_SEGMENT = "CAR-BOOKING";
const __ = key => `${CAR_BOOKING_ACTION_SEGMENT}_${key}`;
export const SET_CAR_BOOKING_PROGRESS = __("SET_CAR_BOOKING_PROGRESS");
export const setCarBookingProgressAction = payload => {
  return { type: SET_CAR_BOOKING_PROGRESS, payload };
};
